import { PosItem } from "../../../interfaces/posSimulator.interface";

type IdentifiablePosItem = Pick<
  PosItem,
  "articleId" | "productReference" | "name"
> & { unitPrice?: number };

export function posItemIdentity(
  item: IdentifiablePosItem,
  fallbackIndex?: number
): string {
  if (item.articleId != null) return `article:${item.articleId}`;
  if (item.productReference) return `ref:${item.productReference}`;
  return fallbackIndex != null
    ? `name:${item.name}-${fallbackIndex}`
    : `name:${item.name}`;
}

export function isSamePosItem(
  a: IdentifiablePosItem,
  b: IdentifiablePosItem
): boolean {
  return (
    posItemIdentity(a) === posItemIdentity(b) &&
    (a.unitPrice ?? null) === (b.unitPrice ?? null)
  );
}
